<template>
<v-main class="polygon">
    <v-app-bar app color="toolbar" flat height=64 class="pa-0" style="border-bottom: 1px solid var(--v-secondary-lighten5) !important;">
        <router-link to="/" style="background-color: var(--v-toolbar-base) !important;">
            <v-toolbar-items class="mr-2">
                <img height=36 src="~@/assets/images/header.svg">
            </v-toolbar-items>
        </router-link>
        <v-toolbar-title class="font-weight-medium">{{$t('title')}}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items justify=center align=center class="py-4">
            <v-btn text color="secondary" :href="documentationPath()" class="subtitle-2 font-weight-medium text-none"
                target="_blank">
                <v-icon left size=20>mdi-text-box-search-outline</v-icon>
                {{ $t('login.documentation') }}
            </v-btn>
            <v-divider vertical style="border-color: var(--v-secondary-lighten5) !important"></v-divider>
            <v-btn text color="secondary" @click="$router.push('/login')" class="body-2 text-none font-weight-medium" target="_blank">
                <v-icon left size=20>mdi-account</v-icon>
                <span class="text-wrap" style="word-break: break-word;">{{ $t('login.title') }}</span>
            </v-btn>
        </v-toolbar-items>
    </v-app-bar>
    <alert-container></alert-container>
<v-container fluid>
        <v-row no-gutters justify=center>
            <v-col cols=12 xs=12 sm=12 md=6 xl=4 lg=4 class="my-8">
                <v-card flat tile color="var(--v-highlight-base)" class="subcaption--text d-flex align-center">
                    <v-card-text class="px-0 pb-0">
                        <v-alert color="primary" text class="mb-0 rounded-0">
                          <v-row no-gutters>
                            <span class="title" v-html="activationLabel"></span>
                          </v-row>
                          <v-divider class="my-4 primary" style="opacity: 0.22"></v-divider>
                              <v-row no-gutters>
                              <v-list dense disabled color="var(--v-deep-orange-base)">
                                <v-list-item-group>
                                  <v-list-item class="list-dense">
                                    <v-list-item-icon class="list-icon">
                                      <v-icon color="primary">mdi-circle-medium</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content class="list-contents">
                                      <v-list-item-title class="text-wrap font-weight-medium primary--text" v-text="$t('userAdministration.userPasswordRequirement.0')"></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item class="list-dense">
                                    <v-list-item-icon class="list-icon">
                                      <v-icon color="primary">mdi-circle-medium</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content class="list-contents">
                                      <v-list-item-title class="text-wrap font-weight-medium primary--text" v-text="$t('userAdministration.userPasswordRequirement.1')"></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item class="list-dense">
                                    <v-list-item-icon class="list-icon">
                                      <v-icon color="primary">mdi-circle-medium</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content class="list-contents">
                                      <v-list-item-title class="text-wrap font-weight-medium primary--text" v-text="$t('userAdministration.userPasswordRequirement.2')"></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item class="list-dense">
                                    <v-list-item-icon class="list-icon">
                                      <v-icon color="primary">mdi-circle-medium</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content class="list-contents">
                                      <v-list-item-title class="text-wrap font-weight-medium primary--text" v-text="$t('userAdministration.userPasswordRequirement.3')"></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                            </v-row>
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense justify="center">
            <v-col cols=12 xs=12 sm=12 md=6 xl=3 lg=3>
          <v-sheet color="var(--v-cards-base)" height=450 elevation=3>
              <v-container fill-height fluid>
                  <v-row dense no-gutters justify="center" align="center">
                      <v-col cols=12 md=12 lg=10 xl=10>
                          <v-card flat tile>
                  <v-tabs :grow="true" background-color="var(--v-cards-base)" slider-color="primary">
                    <v-tab href="#tab-1" class="subtitle-1 font-weight-medium text-none">
                      {{$t('reset.title')}}
                    </v-tab>
                      <v-tab-item :value="'tab-1'">
                          <v-card class="pa-5" tile flat color="var(--v-cards-base)">
                        <v-card-title class="pb-0 primary--text justify-center">
                          {{user.login}}
                        </v-card-title>
                          <v-form @submit.prevent="validateBeforeSubmit" ref="form" @keyup.enter="validateBeforeSubmit">
                        <v-card-text>
                              <v-row no-gutters>
                                <v-col>
                                  <v-text-field type="password" v-model="user.password" class="required"
                                    :label="$t('userAdministration.password')" color="primary subtitle-2"
                                    :error-messages="passwordErrors"
                                    @input="$v.user.password.$touch()"
                                    @blur="$v.user.password.$touch()"
                                    prepend-inner-icon="mdi-lock-outline">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col>
                                  <v-text-field type="password" v-model="user.newPassword" class="required"
                                      :label="$t('userAdministration.confirmPassword')" color="primary subtitle-2"
                                      :error-messages="newPasswordErrors"
                                      @input="$v.user.newPassword.$touch()"
                                      @blur="$v.user.newPassword.$touch()"
                                      prepend-inner-icon="mdi-lock-outline">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-col>
                              <v-row no-gutters class="mt-4">
                                <v-btn tile color="primary" :class="{'disable-events': loading}"
                                  :loading="loading" dark type="submit" class="text-none" block>
                                  {{$t('userAdministration.apply')}}
                                </v-btn>
                              </v-row>
                          </v-col>
                        </v-card-actions>
                          </v-form>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-card>
                    </v-col>
                </v-row>
                </v-container>
        </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</v-main>
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import Vuelidate from 'vuelidate'
import { validationMixin } from '@/mixins/validation'
import { required } from 'vuelidate/lib/validators'
import AlertContainer from '@/components/header/alert-container/AlertContainer.vue'

Vue.use(Vuelidate)
export default {
  components: {
    AlertContainer
  },
  mixins: [validationMixin],
  name: 'reset',
  data () {
    return {
      model: this.value,
      loading: false,
      token: '',
      tokenValid: false,
      user: {
        login: '',
        password: '',
        newPassword: ''
      }
    }
  },
  created () {
    this.logConsole('Reset request received')
    this.token = this.$route.query.token
    const resetToken = { token: this.token }
    this.$http.post(Vue.$apiConfig.resetTokenValidatePost, resetToken)
      .then(response => {
        this.logConsole(response)
        this.tokenValid = true
        this.user = response.body.payload
        this.tokenLoading = false
      }, error => {
        this.logConsole(error)
        this.tokenValid = false
        this.formatErrorResponse(error)
        this.tokenLoading = false
      })
  },
  computed: {
    activationLabel () {
      return `Постављање лозинке - <strong>${this.user.login}</strong>`
    },
    passwordErrors () {
      return !this.$v.user.password.$dirty ? [] : this.getUserValidationErrorsByName('password')
    },
    newPasswordErrors () {
      return !this.$v.user.newPassword.$dirty ? [] : this.getUserValidationErrorsByName('newPassword')
    }
  },
  methods: {
    getUserValidationErrorsByName (name) {
      return this.getValidationErrors('user').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateBeforeSubmit () {
      this.$v.$touch()
      const validationErrors = this.getValidationErrors('user')
      if (validationErrors && validationErrors.length > 0) {
        return
      }

      this.resetUser()
    },
    resetUser () {
      this.logConsole('Resetting user')
      if (this.user.password === this.user.newPassword) {
        this.loading = true
        this.user.activationToken = this.token
        this.$http.post(Vue.$apiConfig.resetUserPost.replace('{login}', this.user.login) + '?token=' + this.token, this.user)
          .then(response => {
            this.logConsole(response)
            this.loading = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('reset.success'),
              errors: []
            })
            this.$refs.form.reset()
            this.user.password = this.user.newPassword = null
            this.$v.$reset()
            this.$router.push('/')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.loading = false
          })
      } else {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('userAdministration.confirmPasswordFail'),
          errors: []
        })
      }
    }
  },
  validations: {
    user: {
      password: {
        required
      },
      newPassword: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .narrow-container {
    width: 800px;
  }

  .activation-info-label {
    font-weight: 500;
    font-size: 15px;
    text-align: center;
  }

  .list-dense {
    min-height: 26px !important;
    padding-left: 0px;
  }
  .list-icon {
    padding: 2px 0px !important;
    margin-right: 16px !important;
    margin-top: 2px !important;
    margin-bottom: 2px !important;
  }

  .list-contents {
    padding: 2px 0px !important;
  }

  .v-list-item__title {
    font-weight: 400 !important;
  }
</style>
